import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { toast } from 'sonner';

const AuthCallback = () => {
  const nav = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    (async () => {
      const hash = window.location.hash || '';
      const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
      const sessionId = params.get('session_id');
      if (!sessionId) {
        nav('/login', { replace: true });
        return;
      }
      try {
        await api.post('/auth/google/session', { session_id: sessionId });
        await checkAuth();
        // Clean hash and go to dashboard
        window.history.replaceState({}, document.title, window.location.pathname);
        toast.success('Signed in');
        nav('/dashboard', { replace: true });
      } catch (e) {
        toast.error('Sign in failed. Please try again.');
        nav('/login', { replace: true });
      }
    })();
  }, [nav, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-sans_bone">
      <div className="text-sans_mute text-sm tracking-wide">Signing you in…</div>
    </div>
  );
};

export default AuthCallback;
